<template >
  <div class="frame">
    <div class="title">
      <div class="left_area">
        <!-- <div class="left_icon">
          <img  v-if="imgScr" :src="imgScr" alt />
        </div> -->
        {{ title }}
      </div>
      <div class="right_area">
        <slot name="rightSlot" />
      </div>
    </div>
    <div class="frame_content">
      <slot name="contentSlot" />
    </div>
  </div>
</template>

<script >
import { RightCircleOutlined, HomeOutlined } from "@ant-design/icons-vue";

export default {
  name: "frame",
  props: {
    title: {
      type: String,
      default: "标题",
    },
    routerTo: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "",
    },
    imgScr: {
      type: String,
      default: "",
    },
  },
  components: {
    RightCircleOutlined,
    HomeOutlined,
  },
};
</script>

<style lang="scss" scoped>
$base_width: 375;
@function pxRem($px) {
  @return ($px / $base_width) * 10 + rem;
}
.frame {
  border-color: rgba(233, 233, 233, 1);
  border-radius: pxRem(5);
  box-shadow: 0 0 pxRem(5) rgba(0, 0, 0, 0.05);
  position: relative;
  background-color: #fff;
  padding:pxRem(10) 0 ;
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 pxRem(10);
    // border-bottom: 1px solid rgba(233, 233, 233, 1);
    .left_area {
      position: relative;
      font-weight: 400;
      font-size: pxRem(12);
      color: #666666;
      display: flex;
      align-items: center;
      .left_icon {
        padding-right: pxRem(16);
        font-weight: 400;
        // color: #409eff;
        img {
          width:40px;
          height:40px;
        }
      }
    }
    // &::before {
    //   position: absolute;
    //   content: "";
    //   width: 20px;
    //   height: 20px;
    //   background: #547dfb;
    //   box-shadow: -3px 0px 8px 3px rgba(83, 125, 251, 0.61);
    //   top: 50%;
    //   left: 0;
    //   transform: translateY(-50%);
    //   border-radius: 50%;
    // }

    .right_area {
      // padding-right: 20px;

      .top_more {
        display: flex;
        align-items: center;
        color: #4B7EF1;
      }
    }
  }
  .frame_content {
  }
}
</style>